import { createApp } from 'vue';
import App from './App.vue';
import i18n from './localization/i18n';
import router from './routes/router';
import globalStyles from './styles.module.css';

//Pinia
const pinia = createPinia();

// Patternlib
import { PatternLibraryPlugin } from '@liebherr/patternlib-vue';
import { createPinia } from 'pinia';
if (import.meta.env.MODE == 'development') {
  // patternlib styles are only imported at local dev mode, in production the surrounding site will provide them
  import('@liebherr/patternlib/dist/patternlib/patternlib.css');
  import('@liebherr/patternlib/www/assets/css/patternlib-fonts.css');
}

//Install Validation Directive
import { createValidation } from '@liebherr/form-validator-vue';

const ValidationPlugin = createValidation({
  validateOnFocusLoss: true,
  initialValidation: false
});

const app = createApp(App)
  .use(i18n)
  .use(PatternLibraryPlugin)
  .use(router)
  .use(pinia)
  .use(ValidationPlugin);

app.config.globalProperties.$gStyle = (str: string) => {
  let scopedStr = '';
  for (let cssClass of str.split(' ')) {
    // import via 'import mainStyles from './main.modules.css' does not return all classes in production so generate function is needed here also
    scopedStr += globalStyles[cssClass]
      ? globalStyles[cssClass] + ' '
      : 'itde-' + cssClass + ' ';
  }
  return scopedStr;
};
app.mount('#itde_application');
